// All the events

export const ACTIONS = {
  JOIN: "join",
  JOINED: "joined",
  JOIN_ERROR: "join-error",
  DISCONNECTED: "disconnected",
  CHAT_MESSAGE: "chat-message",
  CODE_CHANGE: "code-change",
  SYNC_CODE: "sync-code",
  CHANGE_ROLE: "change-role",
  ROLE_UPDATED: "role-updated",
  KICK_USER: "kick-user",
  BAN_USER: "ban-user",
  GET_BANNED_USERS: "get-banned-users",
  BANNED_USERS: "banned-users",
  UNBAN_USER: "unban-user",
  KICKED: "kicked",
  BANNED: "banned",
  FILE_CREATE: "FILE_CREATE",
  FILE_SWITCH: "FILE_SWITCH",
  FILE_UPDATE: "FILE_UPDATE",
  SYNC_FILES: "SYNC_FILES",
  CURSOR_MOVE: "cursor-move",
  SELECTION_CHANGE: "selection-change",
  LEAVE: "leave",
};
